export default __webpack_public_path__ + "static/media/unconfirmedAppt.2842a8e7.svg";